// @noflow
import React from 'react'

import {
  Direction,
  ICON_COLOURS,
  IconColours
} from '@/components/elements/atoms/Icon/Icon'

type Props = {
  size: number
  accentColour: IconColours
  width?: number | string
}

const ChevronFilled = ({ size, accentColour, width }: Props): JSX.Element => {
  return (
    <svg
      width={width || '100%'}
      height={size}
      viewBox="0 0 18 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33686 1.64689C8.13115 0.766138 9.51302 0.766138 10.3073 1.64689L14.2331 6L16.6325 8.66056C17.7928 9.94714 16.8798 12 15.1473 12H2.49687C0.764366 12 -0.148651 9.94714 1.01164 8.66056L7.33686 1.64689Z"
        fill={ICON_COLOURS[accentColour]}
      />
    </svg>
  )
}

export type { Direction }
export default ChevronFilled
